"use client";

import { BreadcrumbsBar } from "@spheron/ui-library";
import { useParams, usePathname, useRouter } from "next/navigation";

const BreadcrumbsContainer = () => {
  const router = useRouter();
  const params = useParams();
  const pathname = usePathname();

  const urlWithFizzAddress = `/${params.fizzAddress}`;

  const handleRedirect = (link: string): void => {
    router.push(link);
  };

  const registerFizzNodeLinks = [
    {
      id: 1,
      linkName: "Dashboard",
      // urlPath: `/${params.fizzAddress}/dashboard`,
      urlPath: `/`,
      // handleClick: () => handleRedirect(`/${params.fizzAddress}/dashboard`),
      handleClick: () => handleRedirect(`/`),
    },
    {
      id: 2,
      linkName: "Register Fizz Node",
      urlPath: `/${params.fizzAddress}/register`,
      handleClick: () => {},
    },
  ];

  const myFizzNodeLinks = [
    {
      id: 1,
      linkName: "Dashboard",
      // urlPath: `/${params.fizzAddress}/dashboard`,
      urlPath: `/`,
      // handleClick: () => handleRedirect(`/${params.fizzAddress}/dashboard`),
      handleClick: () => handleRedirect(`/`),
    },
    {
      id: 2,
      linkName: "My Fizz Node",
      urlPath: `/${params.fizzAddress}/my-fizz`,
      handleClick: () => {},
    },
  ];

  const dashboardLinks = [
    {
      id: 1,
      linkName: "Dashboard",
      urlPath: `/${params.fizzAddress}/dashboard`,
      handleClick: () => handleRedirect(`/`),
    },
  ];

  const breadcrumbsLinkMap = {
    [`${urlWithFizzAddress}/register`]: registerFizzNodeLinks,
    [`${urlWithFizzAddress}/my-fizz`]: myFizzNodeLinks,
  };

  const links = breadcrumbsLinkMap[pathname];
  const activeLink = links?.find((link) => pathname === (link.urlPath));

  if (breadcrumbsLinkMap[pathname]) {
    return (
      <div className="bg-base-fg dark:bg-dark-base-fg w-full mx-auto">
        <div className="lg:px-14 px-4 max-w-[1400px] mx-auto">
          <BreadcrumbsBar
            links={breadcrumbsLinkMap[pathname]}
            activeLink={activeLink?.urlPath || ""}
            type="default"
            actions={[]}
          />
        </div>
      </div>
    );
  }

  return null;
};

export default BreadcrumbsContainer;
